/**
 * Service worker registration.
 *
 * Production only: in dev the worker would sit in front of Vite's HMR and serve
 * stale modules, which is a debugging trap nobody needs.
 *
 * `updateViaCache: 'none'` keeps the browser from serving sw.js out of the HTTP
 * cache. Without it a long max-age on the static host would pin an old worker in
 * place and the next deploy would not reach anyone who had already installed it.
 *
 * Registration waits for `load` so it never competes with the first render for
 * bandwidth — the worker matters on the second visit, not this one.
 */
export function registerServiceWorker(): void {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  if (!import.meta.env.PROD) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${import.meta.env.BASE_URL}sw.js`, { updateViaCache: 'none' })
      .catch(() => {
        // A failed registration must never break the page: the site works
        // exactly as before without a worker.
      });
  });
}
